import { useRef, useState } from 'react';
import { api } from '../lib/api.js';

/** §21.8 — "Explain this match" inline expansion (Haiku, 24h cached). */
export function ExplainWhy({ eventId, zoneId }: { eventId: number; zoneId: number }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const fetched = useRef(false);

  const onClick = async () => {
    setOpen((v) => !v);
    if (fetched.current) return;
    fetched.current = true;
    setLoading(true);
    try {
      const r = await api.explainMatch(eventId, zoneId);
      setText(r.explanation);
    } catch {
      setText('Explanation unavailable — set ANTHROPIC_API_KEY to enable.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-1">
      <button
        type="button"
        onClick={onClick}
        className="text-[11px] text-[var(--color-muted)] underline"
      >
        {open ? 'Hide' : 'Why?'}
      </button>
      {open && (
        <p className="mt-1 rounded bg-[var(--color-panel)] p-2 text-[11px] text-[var(--color-muted)]">
          {loading ? 'Thinking…' : text}
        </p>
      )}
    </div>
  );
}
